import { render, staticRenderFns } from "./consumerListDialog.vue?vue&type=template&id=64c5e41a&scoped=true"
import script from "./consumerListDialog.vue?vue&type=script&lang=js"
export * from "./consumerListDialog.vue?vue&type=script&lang=js"
import style0 from "./consumerListDialog.vue?vue&type=style&index=0&id=64c5e41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5e41a",
  null
  
)

export default component.exports